module.exports = __webpack_public_path__ + "f2b31e07e0e2fcc3c2f243100b02b973.pdf";